import { theme } from "antd";
import { dimensions, SvgIconProps } from "./SvgIcon";

export const VzblIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props, { size: 13 });
  const { token } = theme.useToken();
  const fill = props.style?.fill || token.colorTextSecondary;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.77539 0.875H6.03125V4.25879L4.37964 6.03125H2.58704L0.875 4.25879V0.875H3.13086V3.45312H3.77539V0.875Z"
        fill={fill}
      />
      <path
        d="M6.96875 6.96875H10.8359V9.54688H12.125V12.125H6.96875V6.96875Z"
        fill={fill}
      />
      <path
        d="M12.125 0.875H6.96875V3.45312H8.25781L6.96875 4.74219V6.03125H12.125V3.45312H10.8359L12.125 2.16406V0.875Z"
        fill={fill}
      />
      <path
        d="M0.875 12.125V6.96875H5.38672L6.03125 7.61328V8.84192L5.38672 9.48645L6.03125 10.131V11.4805L5.38672 12.125H0.875ZM2.80859 10.8359H4.09766V10.1914H2.80859V10.8359ZM2.80859 8.90234H4.09766V8.25781H2.80859V8.90234Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
      />
    </svg>
  );
};
